import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "border-b border-amber-400/20 bg-amber-500/10 px-4 py-2 flex items-center justify-between"
}
const _hoisted_2 = { class: "text-sm text-amber-200" }

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import TopNav from './components/TopNav.vue';
import CookieConsentBanner from './components/CookieConsentBanner.vue';
import { useOrdersStore } from './store/orders';
import { useAppUpdate } from './composables/useAppUpdate';
import { applyRegionalLanguageDefault } from './composables/useLanguage';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const ordersStore = useOrdersStore();
const { bannerVisible, bannerText, actionLabel, actionVisible, action } = useAppUpdate();
const hideTopNav = computed(() => Boolean(route.meta.hideTopNav));
onMounted(() => {
  ordersStore.connectRealtime();
  void ordersStore.loadOrders();
  // ru/uk are default only in Ukraine; elsewhere fall back to English (manual choice wins).
  void applyRegionalLanguageDefault();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!hideTopNav.value)
      ? (_openBlock(), _createBlock(TopNav, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(bannerVisible) && !hideTopNav.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(bannerText)), 1),
          (_unref(actionVisible))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "rounded-lg px-3 py-1 text-sm font-medium text-amber-100 ring-1 ring-amber-400/30 bg-amber-500/20 hover:bg-amber-500/35 transition",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(action) && _unref(action)(...args)))
              }, _toDisplayString(_unref(actionLabel)), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(CookieConsentBanner)
  ], 64))
}
}

})